import { auth } from "./firebase";

export type RenderResponse = {
  pdf_storage_path: string;
};

export async function renderReport(args: {
  reportId: string;
  pickerAccessToken: string;
}): Promise<RenderResponse> {
  const apiUrl = import.meta.env.VITE_DRAFT_API_URL;
  if (!apiUrl) throw new Error("VITE_DRAFT_API_URL not configured");
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) throw new Error("Not signed in");

  const res = await fetch(`${apiUrl}/render`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      report_id: args.reportId,
      picker_access_token: args.pickerAccessToken,
    }),
  });

  if (!res.ok) {
    const body = await res.json().catch(() => ({ error: res.statusText })) as { error?: string };
    throw new Error(body.error ?? `Render API ${res.status}`);
  }
  return res.json() as Promise<RenderResponse>;
}
